import {
  AgxRow,
  AgxColumn,
  AgxButton,
  AgxBodyText,
  DocumentTypesMap,
} from '@urbanx/agx-ui-components'
import { useQuery } from '@tanstack/react-query'
import { GetDocumentsForCampaigns } from 'services'
import { useContext } from 'react'
import { ContentLayout, PageLayout } from 'layout'
import { MenuTitles } from 'constants/menu'
import { useSelectedAgency, useSelectedCampaign } from 'hooks'
import { DocumentGroup } from 'services/functions/campaigns/getDocumentsForCampaigns'
import DocumentsList from './DocumentsList'
import { openFileInNewTab } from 'utils/openInNewTab'
import './Submissions.scss'
import { AuthContext } from '@urbanx/agx.auth.client'

const Submissions = () => {
  const { getAuthToken, userAccount } = useContext(AuthContext)
  const { agency } = useSelectedAgency()
  const { campaign } = useSelectedCampaign()

  const campaignDocumentsQueryKey = [`campaign-documents`, campaign?.campaignId]

  const { data: docInfoGroups, isLoading: areDocumentsLoading } = useQuery<
    DocumentGroup[] | undefined
  >({
    queryKey: campaignDocumentsQueryKey,
    queryFn: (ctx) =>
      GetDocumentsForCampaigns(getAuthToken, ctx.queryKey[1] as string),
    enabled: !!campaign?.campaignId,
  })

  const getDocumentTypeLabel = (documentType: string) =>
    DocumentTypesMap[documentType as keyof typeof DocumentTypesMap] ??
    documentType

  const downloadAllDocuments = async () => {
    if (docInfoGroups) {
      docInfoGroups.map((docGroup) =>
        docGroup.documents.forEach((docGroup) =>
          openFileInNewTab(getAuthToken, docGroup)
        )
      )
    }
  }

  return (
    <PageLayout
      agentName={userAccount?.firstName || ''}
      primaryPageTitle={agency?.name || ''}
      currentPageTitle="Campaigns"
      isCampaignsSection={true}
    >
      <ContentLayout
        hasSecondaryMenu={false}
        secondaryActiveMenu={MenuTitles.FILES}
        isCampaigns={true}
      >
        <AgxColumn veryLargeGap fill>
          <AgxRow spaceBetween extraClasses="borderBottomContainer">
            <AgxRow largeGap>
              <AgxBodyText large>Files</AgxBodyText>
            </AgxRow>
            <AgxButton
              text="Download all"
              medium
              hollow
              onClick={downloadAllDocuments}
            />
          </AgxRow>
          {!areDocumentsLoading && docInfoGroups ? (
            <DocumentsList
              documentsInfo={docInfoGroups}
              getDocumentTypeLabel={getDocumentTypeLabel}
            />
          ) : (
            <AgxBodyText medium>No documents found</AgxBodyText>
          )}
        </AgxColumn>
      </ContentLayout>
    </PageLayout>
  )
}

export default Submissions
